<template>
    <div>
        <div v-if="loadingError" class="alert alert-danger text-center" style="margin-top:150px;">
            {{loadingError}}
        </div>
        <div v-else-if="!user" class="text-center text-muted" style="padding:100px;">
            Lütfen bekleyiniz...
        </div>
        <fieldset :disabled="loading" v-else>
            <div class="roundbox">
                <div class="rbcontent">
                    <div class="row mb-1">                         
                        <div class="col">                    
                            <h2>{{data.Title}}</h2>                            
                        </div>      
                        
                        <a :href=imgLogoUrlPath target="_blank" title="İzOnay"><img :src="imgLogoPath" class="float-right"/></a>                                                                 
                                             
                    </div>
                    <div class="row">
                        <div class="col">
                            <div style="font-size:1.2em;">
                                <b>Sayın {{user.FullName}};</b><br/>
                                <div v-if="userActions.CanSign || userActions.CanApprove">
                                    <span>Aşağıda detayları yer alan {{data.Documents.length}} dosya için {{stepActionLabel}} bekleniyor.</span>
                                </div>
                                <div v-else-if="data.UserState.Position == 'Approved'" class="alert alert-success">
                                    {{data.UserState.Date | datetime}} tarihinde tarafınızdan {{(data.UserState.Description || '').toLowerCase()}}.
                                </div>
                                <div v-else-if="data.UserState.Position == 'Declined'" class="alert alert-warning">
                                    İş, {{data.UserState.Date | datetime}} tarihinde tarafınızdan {{(data.UserState.Description || '').toLowerCase()}}.
                                </div>
                                <div v-else-if="data.UserState.Position == 'Directed'" class="alert alert-warning">
                                    İş, {{data.UserState.Date | datetime}} tarihinde tarafınızdan {{(data.UserState.Description || '').toLowerCase()}}.
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr/>
                    <div class="row">
                        <div class="col">                            
                            <div class="row">                                        
                                <label for="AccountTitle" class="col-sm-4 col-lg-3 col-form-label">Hesap</label>
                                <div class="col-sm-8 col-lg-9">
                                <span class="form-control-plaintext">{{data.Account.Title}}</span>
                                <!-- <input type="text" readonly class="form-control-plaintext" id="AccountTitle" :value="data.Account.Title"> -->
                                </div>
                            </div>

                            <div class="row">
                                <label for="AccountTitle" class="col-sm-4 col-lg-3  col-form-label">Sorumlu</label>
                                <div class="col-sm-8 col-lg-9">
                                <span class="form-control-plaintext">
                                    {{data.Owner.FullName}}
                                    <br>
                                    <small class="text-muted" v-if="data.Title && data.Title.Name">{{data.Title.Name}}<br></small>
                                    <small class="text-muted" v-if="data.Department && data.Department.Description">{{data.Department.Description}}<br></small>
                                    <a :href="`mailto:${data.Owner.Email}?subject=${data.TrackingNo.Serial}-${data.TrackingNo.Number} Numaralı İş Hakkında`">{{data.Owner.Email}}</a><br>
                                </span>
                                </div>
                            </div>

                            <div class="row">
                                <label for="TrackingNo" class="col-sm-4 col-lg-3 col-form-label">Takip No</label>
                                <div class="col-sm-8 col-lg-9">
                                <span class="form-control-plaintext"><strong>{{data.TrackingNo.Serial}} - {{data.TrackingNo.Number}}</strong></span>
                                <!-- <input type="text" readonly class="form-control-plaintext" id="AccountTitle" :value="data.Account.Title"> -->
                                </div>
                            </div>

                            <div class="row" v-if="data.TargetDate">
                                <label for="TargetDate" class="col-sm-4 col-lg-3 col-form-label">Hedeflenen Bitiş Tarihi</label>
                                <div class="col-sm-8 col-lg-9">
                                <span class="form-control-plaintext">{{data.TargetDate | datetime}}</span>
                                </div>
                            </div>

                            <div class="row" v-if="data.Description">
                                <label for="Description" class="col-sm-4 col-lg-3 col-form-label">Açıklama</label>
                                <div class="col-sm-8 col-lg-9">
                                <span class="form-control-plaintext">{{data.Description}}</span>
                                </div>
                            </div>

                            
                            <div class="row">
                                <label for="jobStatusLabel" class="col-sm-4 col-lg-3 col-form-label">Mevcut Durum</label>
                                <div class="col-sm-8 col-lg-9">
                                <span class="form-control-plaintext">
                                    <label class="badge" :class="'badge-' + jobStatusClass">{{jobStatusLabel}}</label>
                                </span>                                
                                </div>
                            </div>


                            <div class="row mb-3">
                                <div class="col-sm-4 col-lg-3">Dosyalar</div>
                                <div class="col-sm-8 col-lg-9">
                                    <div  v-for="d in data.Documents" :key="d.id" class="row pt-2" >
                                        <div class="col-sm-6">
                                            <file-download-link :document="d" @download="downloadDocument" @preview="showFilePreview"></file-download-link>
                                            <!-- <a href="#void" @click="downloadDocument(d)">{{d.UnsignedFile.FileName}}</a>
                                            <span v-if="d.SignedFile">
                                                (<a href="#void" @click="downloadDocument(d, true)" title="Dosyanın imzalı veriyonunu indirin">İmzalı</a>)
                                            </span> -->
                                        </div>
                                        <div class="col-sm-6 text-right">
                                           <span class="text-muted">{{d.UnsignedFile.Size | prettyBytes}}</span>
                                        </div>
                                    </div>                                
                                </div>
                            </div>

                            
                            <div class="row">
                                <div class="col-sm-4 col-lg-3">Ekler</div>
                                <div class="col-sm-8 col-lg-9" v-if="data.Attachments && data.Attachments.length > 0">
                                    <div v-for="d in data.Attachments" :key="d.id" class="row pt-2" >
                                        <div class="col-sm-6">
                                            <!-- <a href="#void" @click="downloadAttachment(d)">{{d.FileName}}</a> -->
                                            <file-download-link :document="d" @download="downloadAttachment" @preview="showFilePreview"></file-download-link>
                                            <div style="font-size: 0.7rem; color:#333;" v-if="d.Date">
                                                <span v-if="d.User">{{d.User.FullName}}</span>  - {{d.Date | datetime}}
                                            </div>
                                        </div>
                                        <div class="col-sm-6 text-right">
                                           <span class="text-muted">{{d.Size | prettyBytes}}</span>
                                           <button class="btn btn-sm btn-light" title="Dosyayı kaldır" @click="removeAttachment(d)" v-if="d.CanRemove">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                                                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                                                    <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                                                </svg>
                                            </button>
                                        </div>
                                    </div>                                
                                </div>
                                <div v-else class="col-sm-8 col-lg-9">
                                    <span class="text-muted">Ek dosya yok.</span>    
                                </div>
                                <div class="col-12 pt-2">                                    
                                    <div class="float-right" style="cursor:pointer;" v-if="data.CanAddAttachment">
                                        <file-upload
                                            ref="uploadAttachments"
                                            input-id="attachmentUpload"
                                            label-style="cursor:pointer;"
                                            v-model="attachments"
                                            :post-action="
                                                axios.defaults.baseURL +
                                                '/jobattachment/addfile/' +
                                                data.Id
                                            "
                                            :multiple="true"
                                            :drop="false"
                                            :thread="1"
                                            @input="$refs.uploadAttachments.active = true"
                                            chunk-enabled
                                            :chunk="{
                                            headers: {
                                                token: axios.defaults.headers.common['token'],
                                            },
                                            action:
                                                axios.defaults.baseURL + '/jobattachment/',
                                            minSize: 0,
                                            maxActive: 3,
                                            maxRetries: 3,

                                            // Example in the case your backend also needs the user id to operate
                                            startBody: {
                                                //user_id: user.id
                                            },
                                            }"
                                        >
                                            <!-- <div class="row select-file" id="attachments">
                                                <div class="col">
                                                    İşe dahil edilecek ek dosyaları seçmek için buraya tıklayınız...
                                                </div>
                                            </div> -->
                                            <button type="button" class="btn btn-sm btn-outline-success">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus" viewBox="0 0 16 16">
                                                    <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                                                </svg>
                                                Dosya Ekle
                                            </button>
                                        </file-upload>
                                    </div>
                                    <ul>
                                        <!-- <li>{{file.name}} {{file.active}} {{file.success}} {{file.progress}} {{file.error}}</li> -->
                                        <li
                                        v-for="file in attachments"
                                        :key="file.id"
                                        v-show="!file.success"
                                        >
                                        <div>{{ file.name }}</div>
                                        <div class="progress" v-if="file.active">
                                            <div
                                            class="progress-bar progress-bar-striped progress-bar-animated text-left"
                                            role="progressbar"
                                            :aria-valuenow="file.progress"
                                            aria-valuemin="0"
                                            aria-valuemax="100"
                                            :style="{ width: file.progress + '%' }"
                                            >
                                            &nbsp;%{{ parseInt(file.progress, 10) }}
                                            </div>
                                        </div>
                                        <div class="text-danger" style="font-size:0.8rem" v-if="file.error">
                                            <div v-for="ms in file.response.ModelState" :key="ms">
                                                <div v-for="err in ms" :key="err">{{err}}</div>
                                            </div>
                                        </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div v-if="data.UserState && data.UserState.Note" class="mb-1 row">
                                <label for="TrackingNo" class="col-sm-2 col-form-label">Not</label>
                                <div class="col-sm-10">
                                <span class="form-control-plaintext">
                                    {{data.UserState.Note}}
                                </span>                                
                                </div>
                            </div>

                            <div class="row" v-show="userActions.CanApprove || userActions.CanSign || userActions.CanDecline || userActions.IsDirect" style="margin-top:40px;">
                                <label class="col-sm-12 col-form-label">Açıklama:</label>
                                <div class="col-sm-12">
                                    <textarea class="form-control" maxlength="500" placeholder="Onayınıza ilişkin not veya red gerekçeniz..." v-model="description" rows="3"></textarea>
                                </div>
                            </div>
                            <div class="form-group" v-if="userActions.CanApprove">
                                <label>
                                    <input type="checkbox" v-model="approveCheck" required>
                                    Dokümanları inceledim ve onaylıyorum.
                                </label>
                            </div>
                            <div class="row pt-4" style="justify-content: space-between;">
                                <div class="col">
                                    <button type="button" class="btn btn-danger" @click="decline" v-show="userActions.CanDecline">Reddet</button>
                                    <button type="button" class="btn btn-success" @click="approve" v-show="userActions.CanApprove" style="margin-left:10px;">Onayla</button>
                                    <button type="button" class="btn btn-warning" @click ="showDirectPanel()" v-show="userActions.IsDirect" style="margin-left:10px;">Yönlendir</button>
                                    <button type="button" class="btn btn-primary" @click="showSignaturePanel()" v-show="userActions.CanSign" style="margin-left:10px;">İmzala</button>
                                    <button type="button" class="btn btn-info"  @click="showMobilePanel()" v-show="userActions.CanSign" style="margin-left:10px;">Mobil İmzala</button> 
                                </div>
                            </div>
                            <div style="height:20px;"></div>
                        </div>

                        <!-- İMZA MODAL -->
                        <div v-if="isSignaturePanelVisible" class="modal fade show" style="display: block" tabindex="-1" role="dialog">
                            <div class="modal-dialog modal-lg modal-dialog-centered">
                                <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">İmzala</h5>
                                    <button type="button" class="close" data-dismiss="modal" :disabled="imzalayiciLoading" aria-label="Kapat" @click="isSignaturePanelVisible=false">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <imzalayici ref="imzalayici" :items="signingItems" :identityNumber="identityNumber" userCertificateUrl="/usercertificate" @onloading="imzalayiciOnLoading" @completed="signingCompleted" :processingMessage="processingMessage"></imzalayici>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-outline-secondary" :disabled="imzalayiciLoading" @click="isSignaturePanelVisible = false">Kapat</button>
                                    <button type="button" class="btn btn-danger" style="width:100px;" v-show="imzalayiciLoading" @click="$refs.imzalayici.cancel()" data-dismiss="modal">İptal</button>
                                    <button type="submit" class="btn btn-success" style="width:100px;" v-show="!imzalayiciLoading" @click="$refs.imzalayici.sign()">İmzala</button>
                                </div>
                                </div>
                            </div>
                        </div>
                        <!-- İMZA MODAL SONU -->
                        <!-- MOBİL İMZA MODAL -->
                        <div v-if="isMobilePanelVisible" class="modal fade show" style="display: block" tabindex="-1" role="dialog">
                            <div class="modal-dialog modal-lg modal-dialog-centered">
                                <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Mobil İmza İle İmzala</h5>
                                    <button type="button" class="close" data-dismiss="modal" :disabled="imzalayiciLoading" aria-label="Kapat" @click="isMobilePanelVisible=false">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <mobil-imzala ref="mobileSign" :items="mobileItems" @onloading="imzalayiciOnLoading" @completed="signingCompleted" :processingMessage="processingMessage"></mobil-imzala>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-outline-secondary" @click="closeMobileSignModal()">Kapat</button>
                                    <!-- <button type="button" class="btn btn-danger" style="width:100px;" v-show="imzalayiciLoading" @click="$refs.mobileSign.cancel()" data-dismiss="modal">İptal</button> -->
                                    <button type="submit" class="btn btn-success" style="width:100px;" :disabled="imzalayiciLoading" @click="$refs.mobileSign.sign()">İmzala</button>
                                </div>
                                </div>
                            </div>
                        </div>
                        <!-- MOBİL İMZA MODAL SONU -->
                        <!-- OTP ONAYLAMA MODAL BAŞLANGICI -->
                        <div
                            v-if="isOTPPanelVisible"
                            class="modal fade show"
                            style="display: block"
                            tabindex="-1"
                            role="dialog"
                        >
                            <div class="modal-dialog modal-dialog-centered">
                            <div class="modal-content">
                                <div class="modal-header">
                                <h5 class="modal-title">SMS Kimlik Doğrulama</h5>
                                <button
                                    type="button"
                                    class="close"
                                    data-dismiss="modal"
                                    :disabled="loading"
                                    aria-label="Kapat"
                                    @click="isOTPPanelVisible = false"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                                </div>
                                <div class="modal-body">
                                <div v-if="this.validationResult">
                                    <form @submit.prevent="validate">
                                    <fieldset :disabled="loading">
                                        <p v-if="this.validationResult.Mobile">
                                        <b>{{ this.validationResult.Mobile }}</b> numaralı telefonunuza doğrulama kodu SMS
                                        olarak gönderilmiştir ve kısa süre içerisinde ulaşacaktır.
                                        </p>
                                        <p v-else>
                                        Telefonunuza doğrulama kodu SMS olarak gönderilmiştir ve kısa süre
                                        içerisinde ulaşacaktır.
                                        </p>

                                        <div class="form-group">
                                        <label>Lütfen telefonunuza gelen doğrulama kodunu giriniz:</label>
                                        <input
                                            v-model="form.mFAExternalOTP.Secret"
                                            type="text"
                                            class="form-control text-center"
                                            aria-describedby="validationCodeHelp"
                                            required
                                        />
                                        </div>
                                        <div v-if="errorMessage" class="text-danger">
                                        Hata: {{ errorMessage }}
                                        </div>
                                        <div v-show="processingMessage" class="text-center text-primary" style="line-height:32px;">
                                            <img src="../assets/loading_blue.gif" />
                                            {{processingMessage}}
                                        </div>
                                    </fieldset>
                                    </form>
                                </div>
                                <div v-else>
                                    <div v-show="processingMessage" class="text-center text-primary" style="line-height:32px;">
                                        <img src="../assets/loading_blue.gif" />                    
                                        Yükleniyor...
                                    </div>
                                </div>        
                                </div>
                                <div class="modal-footer">
                                <button
                                    type="button"
                                    class="btn btn-outline-secondary"
                                    @click="isOTPPanelVisible = false"
                                >
                                    Kapat
                                </button>
                                <button
                                    type="submit"
                                    class="btn btn-success"
                                    style="width: 100px"
                                    :disabled="loading"
                                    @click="validate"
                                >
                                    Doğrula
                                </button>
                                </div>
                            </div>
                            </div>
                        </div>
                        <!-- OTP ONAYLAMA MODAL SONU -->
                        <div v-if="showDirectionModal" class="modal fade show" style="display: block" tabindex="-1" role="dialog">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Yönlendir</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Kapat" @click="showDirectionModal=false">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <div style="padding:30px 10px 15px 10px; height:350px ;">
                                        <div text="Dış Kullanıcı">
                                            <div class="form-group row">
                                                <label for="NewRecipient.FirstName" class="col-md-4 col-form-label">Ad</label>
                                                 <div class="col-md-8">
                                                    <input type="text" class="form-control" id="NewRecipient.FirstName" name="FirstName" @change="newRecipient.FullName = newRecipient.FirstName + ' ' + newRecipient.LastName" v-model="newRecipient.FirstName" required/>
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <label for="NewRecipient.LastName" class="col-md-4 col-form-label">Soyad</label>
                                                <div class="col-md-8">
                                                    <input type="text" class="form-control" id="NewRecipient.LastName" name="LastName" @change="newRecipient.FullName = newRecipient.FirstName + ' ' + newRecipient.LastName" v-model="newRecipient.LastName" required/>
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <label for="NewRecipient.Email" class="col-md-4 col-form-label">E-Posta</label>
                                                <div class="col-md-8">
                                                    <input type="email" class="form-control" id="NewRecipient.Email" name="Email" v-model="newRecipient.Email" required/>
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <label for="NewRecipient.Phone" class="col-md-4 col-form-label">Telefon</label>
                                                <div class="col-md-8">
                                                    <div class="input-group">
                                                        <div class="input-group-prepend">
                                                            <span class="input-group-text" id="basic-addon1">+90</span>
                                                        </div>
                                                        <input type="tel" class="form-control" id="NewRecipient.Phone" maxlength="10" placeholder="5XXXXXXXXX" name="Phone" v-model="newRecipient.Mobile" required/>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <label for="NewRecipient.IdentityNumber" class="col-md-4 col-form-label">TCKN</label>
                                                <div class="col-md-8">
                                                    <input type="number" class="form-control" id="NewRecipient.IdentityNumber" name="IdentityNumber" v-model="newRecipient.IdentityNumber"/>
                                                </div>
                                            </div>
                                            <!-- <div class="form-group row">
                                                <label  class="col-md-4 col-form-label">Mobil İmza Operatörü</label>
                                                <div class="col-md-8">
                                                    <select @change="mobileSignOperator" v-model="newRecipient.MobileSignOperator" class="form-control">
                                                        <option value="">Mobil imzası yok</option>
                                                        <option value="TURKCELL">Turkcell</option>
                                                        <option value="AVEA">Türk Telekom</option>
                                                        <option value="VODAFONE">Vodafone</option>
                                                    </select>
                                                </div>
                                            </div> -->
                                        </div>        
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-outline-secondary" @click="showDirectionModal = false">Kapat</button>
                                    <button type="submit" class="btn btn-primary" @click="sendNewRecipientUserForm()">Yönlendir</button>
                                </div>
                                </div>
                            </div>
                        </div>
                        <!-- İMZALAMA TAMAMLANDI MODAL BAŞLANGICI -->
                        <div v-if="isSignatureSuccess" class="modal fade show" style="display: block" tabindex="-1" role="dialog">
                            <div class="modal-dialog modal-lg modal-dialog-centered">
                                <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">İmzalama Başarıyla Tamamlandı !</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Kapat" @click="isSignatureSuccess=false">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body mb-2">
                                    <h5 style="text-align: center;">İmzalanan Dosyalar</h5>
                                    <!-- <button type="button" @click="print">print</button> -->
                                    <div style="display: flex; align-items: center; justify-content: center; flex-direction: column;">
                                        <div  v-for="d in data.Documents" :key="d.id" class="row pt-2" style="width:60%">
                                            <div class="col-sm-6">
                                                <a href="#void" @click="downloadDocument(d)">{{d.UnsignedFile.FileName}}</a>
                                                <span v-if="d.SignedFile">
                                                    (<a href="#void" @click="downloadDocument(d, 'downloadSigned')" title="Dosyanın imzalı veriyonunu indirin">İmzalı</a>)
                                                </span>
                                            </div>
                                            <div class="col-sm-6 text-right">
                                            <span class="text-muted">{{d.UnsignedFile.Size | prettyBytes}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-outline-secondary" @click="isSignatureSuccess = false">Kapat</button>
                                    <button type="button" class="btn btn-info" style="width:max-content;" @click="downloadAll()">Tümünü İndir</button>
                                    <button type="submit" class="btn btn-success" style="width:max-content;" @click="sendAll()">E-Posta İle Gönder</button>
                                </div>
                                </div>
                            </div>
                        </div>
                        <!-- İMZALAMA TAMAMLANDI MODAL SONU -->
                        <file-preview v-if="fileDetail" :file="fileDetail" :isOnlineView="onlineViewEnabled" :viewer="viewerType" @close="fileDetail=null;"></file-preview>
                    </div>
                </div>
            </div>
        </fieldset>
    </div>
</template>
<script>
import axios from 'axios'
import formMixin from '../formMixin.js';
import imzalayici from '../components/Imzalayici.vue'
import mobilImzala from '../components/MobileSign.vue'
import fileUpload from "vue-upload-component"; // https://lian-yue.github.io/vue-upload-component/#/en/documents#getting-started-npm
import FileDownloadLink from '../components/FileDownloadLink.vue';
import FilePreview from '../components/FilePreview.vue';

export default {
    mixins: [formMixin],
    components: {
        imzalayici,
        mobilImzala,
        fileUpload,
        FileDownloadLink,
        FilePreview
    },
    created(){
        this.getData();
        this.newRecipient = Object.assign({}, this.value);
    },
    data(){
        return {
            job: {TrackingNo:{}},
            description: null,
            approveCheck: false,
            isSignaturePanelVisible:false,  // Token ile imzalama paneli aktif mi
            isMobilePanelVisible: false,    // Mobil imza ile imzalama paneli aktif mi
            isSignatureSuccess: false,      // İmzalama işlemi başarılı bir şekilde sonlandı mı 
            signError : null,               // İmzalama işlemi sırasındaki hata mesajı
            loadingError: null,             // getData() ile kayıt yüklenemezse görüntülnecek hata mesajı
            signingItems: [],
            loading: false,
            data: { TrackingNo: {}},        // Job
            userActions: {},                // Kullanıcı aksiyonları. (CanSign, CanDecline vb.)
            user: null,                 // Dış imzacı
            imzalayiciLoading: false,   // İmzalayıcı 'loading' pozisyonunda mı
            mobileSignLoading: false,   // Mobil imza 'loading' pozisyonunda mı
            finalizerDetail: null,      // Detayları popup içinde görüntülenecek hedef sistem. Boş olursa popup görüntülenmez
            fileDetail: null,           // Önizlemesi görüntülenecek dosya
            onlineViewEnabled: true,
            attachments: [],
            showDirectionModal: false,
            newRecipient: null,
            isOTPPanelVisible: false,
            validationResult: {},
            form: {
                Description: null,
                mFAExternalOTP: {
                    SessionId: "",
                    Secret: "",
                }
            },
        };
    },
    watch: {
        attachments: function (oldFiles, newFiles) {
        newFiles
            .filter((x) => x && x.response.attachment)
            .forEach((element) => {
            if (
                this.data.Attachments.filter(
                (d) => d.Id == element.response.attachment.Id
                ).length == 0
            ) {
                this.data.Attachments.push(element.response.attachment);
                console.log("Attachments", this.data.Attachments);
            }

            this.$refs.uploadAttachments.remove(element);
            });
        },
    },
    methods: {
        downloadAll(){
            var downloadUrl = `job/aftersignaction?type=download`;
            return axios.get(downloadUrl,{
                responseType: 'arraybuffer',
            })
            .then((response) => {
                console.log(response)
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', this.data.TrackingNo.Serial + '-' + this.data.TrackingNo.Number +'.zip'); //or any other extension
                document.body.appendChild(link);
                link.click();
            })
            .catch((error) => console.log(error));
        },
        sendAll(){
            var url = `job/aftersignaction?type=email`;
            return axios.get(url).then(x=> {
                if(x.data.Success)
                {
                    this.loading = false;
                    this.isSignatureSuccess = false;
                    this.$alert('Mail Gönderme İşlemi Başarılı !', 'Başarılı', 'success');
                }
                else{
                     this.$alert(x.data.ErrorMessages , "Hata", "warning");
                }
            })
            .catch(x => {
                 this.$alert(x , "Hata", "error");
            })
        },
        print(){
            console.log(this.data)
        },
        closeMobileSignModal(){
            this.isMobilePanelVisible = false;
            this.imzalayiciLoading = false;
        },
        setLoading(isLoading){
            this.loading = isLoading;
            this.$emit('onloading', isLoading);
        },
        chooseAuthority(e){
            this.newRecipient.authority = e.target.value;
        },
        mobileSignOperator(e){
             if(e.target.value != "") {
                this.newRecipient.MobileSignOperator = e.target.value;               
            }
        },
        showDirectPanel(){
            this.showDirectionModal = true;
        },
        sendNewRecipientUserForm(){
            console.log(this.newRecipient)
            var url = `/NewRecipient`;
            return axios.post(url, this.newRecipient).then(x=> {
                if(x.data.Success)
                {
                    this.loading = false;
                    this.isSignaturePanelVisible = false;
                    this.isMobilePanelVisible = false;
                    this.processingMessage = null;
                    this.showDirectionModal = false,
                    this.newRecipient = "",
                    this.$alert("Yönlendirme başarılı. Mail gönderilmiştir.", "Başarılı", "success").then(() => 
                    {
                        this.getData()
                    });
                }
                else{
                     this.$alert(x.data.ErrorMessages , "Hata", "warning");
                }
            })
            .catch(x => {
                 this.$alert(x , "Hata", "error");
            })
        },
        removeAttachment(document) {
            if(confirm(`${document.FileName} isimli dosya silinecek.`)) {
                this.loading = true;
                axios.delete('jobattachment/' + document.Id).then(x => {
                    this.data.Attachments = x.data;
                    this.loading = false;
                })
                .catch(x => {
                    window.processErrorResponse(x, this);
                    this.loading = false;
                })
            }
        },
        imzalayiciOnLoading(e){
            console.log('onLoading: ', e);
            this.imzalayiciLoading = e;
        },
        signingCompleted(){
            // Dosyaların imzalanması tamamlandığında sunucu tarafında kabul işlemini başlatır.
            // Bu metodu imzalayıcı componenti @complete eventinde tetikler
            this.loading = true;

            this.processingMessage = 'İmzalanan dosyalar işleniyor. Lütfen bekleyiniz...';
            this.$forceUpdate();

           
            var descriptionQuery = this.description ? `?description=${this.description}` : '';
            var isSuccess = false
            axios.get(`/acceptSignedFiles/${descriptionQuery}`).then(x => {
                if(x.data.Success) {
                    this.getData();
                    isSuccess = true;
                } else {
                    alert(x.data.ErrorMessages);
                }
                if( this.$refs.imzalayici){
                    this.$refs.imzalayici.loading = false;
                }
            }).catch(x => {
                console.warn('Dosya kabul işlemi başarısız: ', x);
                alert("İmzalanan dosya işleme alınamadı.");
            })
            .then(() => {
                this.loading = false;
                this.isSignaturePanelVisible = false;
                this.isMobilePanelVisible = false;
                this.processingMessage = null;
                if(isSuccess){
                    this.showSignatureSuccess();
                }
            });
        },
        showSignaturePanel(){
            // Token imza panelini açar
            axios.get(`/ContentForSign/CheckSigner`).then(x => {                  
                console.log(x); 
                this.signingItems = this.data.Documents.map(x => ({
                DocumentId : x.Id,
                SignatureFormat : x.SignatureFormat,
                FileName : x.UnsignedFile.FileName,
                Size : x.UnsignedFile.Size,
                State : '',
                GetUrl: `/ContentForSign?jobId=${this.data.Id}&documentId=${x.Id}`,
                PostUrl: '/ContentForSign',
                PostParams: { JobId: this.data.Id, DocumentId: x.Id }
            }));
            this.isSignaturePanelVisible = true;            
            }).catch(x => {
                console.log(x);
                alert(`${this.data.TrackingNo.Serial} - ${this.data.TrackingNo.Number} numaralı işin içerisindeki dokümanları daha önce ${this.user.Mobile} numarasına sahip kullanıcı imzaladığı için yeniden imza atamazsınız.`);               
            })             
        },
        showSignatureSuccess(){
           this.isSignatureSuccess = true;
        },
        showMobilePanel(){
            // Mobil imza panelini açar

            axios.get(`/ContentForSign/CheckSigner`).then(x => {  
                console.log(x); 
                this.mobileItems = this.data.Documents.map(x => ({
                DocumentId : x.Id,
                SignatureFormat : x.SignatureFormat,
                FileName : x.UnsignedFile.FileName,
                Size : x.UnsignedFile.Size,
                State : '',
                FingerprintUrl: `/MobileSign/CalculateFingerprint?id=${this.data.Id}&documentId=${x.Id}`,
                PostUrl: `/MobileSign/sign?id=${this.data.Id}&documentId=${x.Id}&fingerPrintTempFileId={0}`,
                PostParams: { JobId: this.data.Id, DocumentId: x.Id }
            }));
            this.isMobilePanelVisible = true;
            }).catch(x => {
                alert(`${this.data.TrackingNo.Serial} - ${this.data.TrackingNo.Number} numaralı işin içerisindeki dokümanları daha önce ${this.user.Mobile} numarasına sahip kullanıcı imzaladığı için yeniden imza atamazsınız.`);               
                console.log(x);
            })     
        },
        decline(){
            // İşi reddeder
            if(!this.description) {
                alert('Lütfen açıklama alanında red gerekçenizi belirtiniz.');
                return;
            }

            this.loading = true;
            var url = `/decline`;

            return axios
              .post(url, { Description: this.description })
              .then(x => {
                console.log("PSOT Result:", x.data);

                if(x.data.Success) {
                    this.data = x.data.Data.Job;
                    this.userActions = x.data.Data.UserActions;
                    //  this.user = x.data.Data.User;
                    this.description = null;
                    this.approveCheck = false;
                } else {
                    alert(x.data.ErrorMessages)
                }

                this.loading = false;
              })
              .catch(x => window.processErrorResponse(x, this));
        },
        approve(){
            // İşi onaylar
            if(!this.approveCheck)
            {
                alert("Lütfen 'Dokümanları inceledim ve onaylıyorum' kutusunu işaretleyiniz.")
                return;
            }
            this.form.Description = this.description;
            this.loading = true;
            var url = `/approve`;

            return axios
              .post(url, this.form)
              .then(x => {
                console.log("POST Result:", x.data);
                if(x.data.Data.SessionId){
                    this.validationResult = x.data.Data;
                    this.isOTPPanelVisible = true
                    this.form.mFAExternalOTP.SessionId = x.data.Data.SessionId;
                    this.form.Description = this.description;
                    console.log(this.validationResult)
                }
                else if(x.data.Success) {
                    this.data = x.data.Data.Job;
                    this.userActions = x.data.Data.UserActions;
                    //  this.user = x.data.Data.User;

                    this.description = null;
                    this.approveCheck = false;
                } else {
                    alert(x.data.ErrorMessages)
                }

                this.loading = false;
              })
              .catch(x => window.processErrorResponse(x, this));
        },
        validate(){
            this.loading = true;
            this.processingMessage = "Kimlik doğrulanıyor...";
            var url = `/ApproveOTP/ApproveOTP`;
            axios.post(url, this.form)
            .then(x => {
                if(x.data.Success){
                    console.log("Başarılı")
                    this.data = x.data.Data.Job;
                    this.userActions = x.data.Data.UserActions;
                    this.description = null;
                    this.approveCheck = false;
                    this.$alert("Belgeleriniz başarıyla onaylanmıştır.","Başarılı","success");
                } else{
                    alert(x.data.ErrorMessages)
                }
            this.loading = false;
            this.isOTPPanelVisible = false;
            })
            .catch(x => window.processErrorResponse(x, this));
        },
        getData(){
            // Token ile gelen iş bilgilerini çeker
            this.loading = true; 
            let decodedLink =decodeURIComponent(this.$route.query.t)
             axios.defaults.headers.common['token'] = decodedLink;

            return axios
              .get('/job')
              .then(x => {
                console.log("POST Result:", x.data);
                    this.data = x.data.Data.Job;
                    this.user = x.data.Data.User;
                    this.userActions = x.data.Data.UserActions;
                    this.loading = false;
              })
              .catch(x => {
                if(x && x.response && x.response.status == 401)
                {
                    this.$router.push({ path: `/mfa?t=${this.$route.query.t}` });
                    return;
                }

                this.loadingError = 'İmzalanacak işe ilişkin bilgiler teknik bir sorundan dolayı yüklenemedi. Lütfen bir süre sonra tekrar deneyin.';
                console.warn(x);
              });
        },
        downloadDocument(document, menuKey){
            // İndirilecek doküman için dinamik URL'i alır ve tarayıcıyı bu adrese yönlendirir.
            return axios
              .post(`/jobDocumentUrl/`, {
                  EntityId : this.data.Id,
                  DocumentId: document.Id,
                  IsSigned: menuKey == 'downloadSigned' ? true : false,
              })
              .then(x => {
                console.log("jobDocumentUrl Result:", x.data);
                window.open(x.data.Data.Url);
              })
              .catch(x => window.processErrorResponse(x, this));
        },
        downloadAttachment(attachment){
            // İndirilecek ek dosya için dinamik URL'i alır ve tarayıcıyı bu adrese yönlendirir.
            return axios
              .post(`/jobAttachmentUrl/`, {
                  EntityId : this.data.Id,
                  AttachmentId: attachment.Id
              })
              .then(x => {
                console.log("jobAttachmentUrl Result:", x.data);
                window.open(x.data.Data.Url);
              })
              .catch(x => {
                  switch(x.response.status) {
                      case 404:
                        alert('Kayıt bulunamadı.');
                        break;
                    default:
                        this.errorMessage = "İşlem gerçekleştirilemedi: " + x;
                        break;
                  }
                  this.loading = false;
              });
        },
        showFilePreview(document, type) {
            console.log(document);
            this.fileDetail = document;
            this.viewerType = type;
            this.fileDetail.EntityId = this.data.Id;
            console.log(this.fileDetail)
        },
    },
    computed: {
        jobStatusLabel(){
            if(!this.data || !this.data.State)
                return null;
            return window.jobStatus[this.data.State]?.text;
        },
        jobStatusClass(){
            if(!this.data || !this.data.State)
                return null;

            return window.jobStatus[this.data.State]?.css;
        },
        identityNumber(){   // Oturumu açık kullanıcının T.C. kimlik numarası
            console.log("TCKN:", this.user.IdentityNumber);
            return this.user.IdentityNumber;
            //return this.$root.$data.login.user.
        },
        stepActionLabel(){
            switch(this.data.StepAction){
                case 'Sign':
                    return 'imzanız';
                case 'Approve':
                    return 'onayınız';
                default:
                    return this.data.StepAction;
            }
        },
        imgLogoPath() {
        return window.settings.customization?.imgLogo == null ? require("../assets/logo.png") : "../img/" + window.settings.customization.imgLogo;
        },
        imgLogoUrlPath(){
            return window.settings.customization?.imgLogoURL == null ? "https://www.izonay.com/" : window.settings.customization.imgLogoURL;
        }
    }
}
</script>
<style>
label[for="attachmentUpload"] {
    cursor: pointer;
}
.col-form-label{
    color: #6c757d!important;
}
.table {
    margin: 0px;
}
</style>